<template>
  <div class="t-row">
    <div class="t-title" :style="titleStyle" :class="titleClass">
      {{ title }}
    </div>

    <div class="t-value" :style="valueStyle" :class="valueClass">
      {{ value }}
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    // required: true,
  },
  value: {
    // required: true,
  },
  titleStyle: {},
  valueStyle: {},
  titleClass: {},
  valueClass: {},
});
</script>

